import { IUserGroup } from '@boldpenguin/sdk';
import { createSelector } from '@ngrx/store';
import { Dictionary, pickBy } from 'lodash';
import { selectCoreState } from '../core-feature-selector';
import { groupsAdapter } from './user-groups.state';

export const selectUserGroupState = createSelector(
  selectCoreState,
  (state) => state.userGroups,
);

const selectUserGroupEntities = groupsAdapter.getSelectors().selectEntities;

export const selectUserGroups = createSelector(
  selectUserGroupState,
  (users) => users.groups,
);

export const selectUserGroupsLoaded = createSelector(
  selectUserGroupState,
  (state) => state.groupsLoaded,
);

// TODO
export const selectUserGroupsLoadError = createSelector(
  selectUserGroupState,
  (state) => state.loadingGroupsError,
);

export const selectUserGroupEntityDictionary = createSelector(
  selectUserGroups,
  selectUserGroupEntities,
);

/**
 * Selects the dictionary of User Group Entities that should be visible to the user
 */
export const selectViewableUserGroupsEntities = createSelector(
  selectUserGroupEntityDictionary,
  (allUserGroups: Dictionary<IUserGroup>) => {
    const allowedGroups = ['agent', 'principal'];
    return pickBy(
      allUserGroups,
      (group) =>
        !!group && allowedGroups.indexOf(group.name.toLowerCase()) !== -1,
    );
  },
);

export const selectViewableUserGroupsFormOptions = createSelector(
  selectViewableUserGroupsEntities,
  (groupDictionary: Dictionary<IUserGroup>) =>
    Object.values(groupDictionary)
      .filter((v): v is IUserGroup => !!v)
      .map((group) => ({
        id: group.id,
        label: group.name,
        value: JSON.stringify({ id: group.id, name: group.name }),
      })),
);
